import "../DynaView/DynaInput.scss";
import DynaModal from "../Modal/DynaModal";
import DynaButton from "../DynaView/DynaButton";

const SmallModal = ({ onClose, onOp1, onOp2, icon, iconAlt, title, op1, op2 }) => {
  return (
    <DynaModal className={"simple-modal-address delete-modal"}>
      {/* Exit Button */}
      <div className="header-modal">
        <div onClick={onClose}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="close-circle 2">
              <path
                id="Vector"
                d="M13.9902 10.0099L14.8302 9.16992"
                stroke="#EB455F"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                id="Vector_2"
                d="M9.16992 14.8301L11.9199 12.0801"
                stroke="#EB455F"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                id="Vector_3"
                d="M14.8299 14.8299L9.16992 9.16992"
                stroke="#EB455F"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                id="Vector_4"
                d="M4 6C2.75 7.67 2 9.75 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2C10.57 2 9.2 2.3 7.97 2.85"
                stroke="#EB455F"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
          </svg>
        </div>
      </div>

      <div className="content-modal">
        {/* Head Icon */}
        {/* {icon} */}
        <img src={icon} alt={iconAlt} />
        
        {/* title */}
        <span>{title}</span>

        {/* Options */}
        <div className="button-modal">
          {op1 ? <DynaButton className="brown-but" onClick={onOp1}>{op1}</DynaButton> : ''}
          {op2 ? <DynaButton className="brown-but" onClick={onOp2}>{op2}</DynaButton> : ''}
        </div>

      </div>
    </DynaModal>
  );
};
export default SmallModal;
